import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FadeIn } from "./motion/FadeIn";

const faqs = [
  {
    q: "Quelles langues parlez-vous ?",
    a: "Français (langue maternelle), portugais courant et anglais. Toutes les excursions se déroulent en français.",
  },
  {
    q: "Comment réserver et payer ?",
    a: "Tout passe par WhatsApp : on échange sur votre projet, je vous propose un programme, et vous réglez par virement bancaire (compte européen) ou en espèces sur place.",
  },
  {
    q: "Et si la météo n'est pas au rendez-vous ?",
    a: "On adapte. La plupart des excursions peuvent être décalées d'un jour, ou remplacées par une alternative en intérieur. Annulation flexible jusqu'à la veille.",
  },
  {
    q: "Vos excursions sont-elles adaptées aux familles ?",
    a: "Oui, plusieurs expériences sont parfaites avec enfants (visites culturelles, plages secrètes, observation faune). Dites-moi l'âge des enfants et j'ajuste le programme.",
  },
  {
    q: "En combien de temps répondez-vous ?",
    a: "Sous 24h en semaine, souvent dans l'heure. Je suis basée à Rio (UTC-3).",
  },
];

export const HomeFAQ = () => (
  <section className="relative py-16 md:py-28 bg-muted/30 overflow-hidden">
    <div className="absolute top-1/3 -right-20 w-72 h-72 rounded-full bg-roca-yellow/10 blur-3xl blob-float pointer-events-none" />
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl relative">
      <FadeIn className="mb-10 md:mb-14">
        <div className="w-12 h-px bg-roca-yellow mb-6" />
        <h2 className="font-league uppercase text-4xl sm:text-5xl md:text-6xl text-foreground leading-[0.95]">
          Vos questions, mes réponses
        </h2>
      </FadeIn>

      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, i) => (
          <FadeIn key={i} delay={i * 80} direction="up" distance={20}>
            <AccordionItem value={`item-${i}`} className="border-b border-border/60 group transition-colors hover:border-roca-orange/40">
              <AccordionTrigger className="text-left text-base sm:text-lg font-semibold py-5 hover:no-underline group-hover:text-roca-orange transition-colors">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          </FadeIn>
        ))}
      </Accordion>
    </div>
  </section>
);

export default HomeFAQ;
